export default data => dispatch => {
    dispatch({
        type: 'SET_WISHLIST_TOOLTIP_VISIBILITY',
        data
    });
};
